import React, { useEffect, useState } from "react";
import "./Navbar.css";

const links = [
  { id: "about", label: "About" },
  { id: "research", label: "Research" },
  { id: "code", label: "Code" },
  { id: "projects", label: "Projects" },
  { id: "cv", label: "CV" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`navWrap ${scrolled ? "scrolled" : ""}`}>
      <nav className="nav">
        <a className="brand" href="#about">
          John Hash
        </a>

        <div className="navLinks">
          {links.map((l) => (
            <a key={l.id} href={`#${l.id}`} className="navLink">
              {l.label}
            </a>
          ))}
        </div>
      </nav>
    </header>
  );
}
